import React from 'react'
import PropTypes from 'prop-types'
import { navigate } from 'gatsby'

import {
  checkExternalUrl,
  normalizeInternalUrl,
} from 'utils/urlUtils'
import GA4 from 'utils/GA4'
import {
  Package,
  PackageTitle,
  HighlightTagWrapper,
  HighlightTag,
  PackageCard,
  CardMedia,
  CardBody,
  CardTitle,
  PackItem,
  PackItemName,
  PackItemDescription,
  PackBookCta,
  PackMainPrice,
  PackPricesWrapper,
  PackPrice,
  VerticalSeparator,
  TermsAndConditions
} from './styles'


const onLinkPress = (url, newTab) => {
  if (checkExternalUrl(url) || newTab) {
    window.open(url, '__blank')
    return null
  }

  navigate(normalizeInternalUrl(url ?? '#'))
  return null
}

export const ShoppingPackageCard = (props) => {
  const {
    labels,
    name,
    image,
    packageItems,
    bookCtaUrl,
    memberPrice,
    nonMemberPrice,
    packagePrice,
    villageSlug,
    nodeLocale,
    termsAndConditionsLabel,
    termsAndConditionsURL
  } = props

  const sp1highlightTags = packageItems.map(({ highlightTag }) => highlightTag)
  return (
    <Package>
      <PackageTitle>{name}</PackageTitle>
      <HighlightTagWrapper>
        {sp1highlightTags.map(tag => <HighlightTag key={tag}>{tag}</HighlightTag>)}
      </HighlightTagWrapper>
      <PackageCard>
        {image && <CardMedia image={image.portrait.gatsbyImageData} alt={image.altText} />}
        <CardBody>
          <CardTitle>
            {labels.spWhatsIncludedLabel}
          </CardTitle>
          {packageItems.map(packageItem => (
            <PackItem key={packageItem.id}>
              <PackItemName>{packageItem.name}</PackItemName>
              <PackItemDescription html={packageItem.itemDesc?.childMarkdownRemark?.html} />
            </PackItem>
          ))}
          <PackBookCta onClick={() => {
            GA4('shopping_packages_book_cta',{
              village_name: villageSlug ,
              page_location: window.location.href,
              package_name: labels.spWhatsIncludedLabel,
              cta_text:labels.spBookCtaLabel,
              content_group:'shopping_packages',
              language:nodeLocale
            })
          onLinkPress(bookCtaUrl)}}>
            {labels.spBookCtaLabel}
          </PackBookCta>
          {!!memberPrice && (
            <PackMainPrice>
              {`${labels.spMemberPriceLabel} ${memberPrice}`}
            </PackMainPrice>
          )}
          <PackPricesWrapper>
            {!!nonMemberPrice && (
              <PackPrice>
                <i>
                  {labels.spNonMemberPriceLabel} {nonMemberPrice}
                </i>
              </PackPrice>
            )}

            {
              (!!nonMemberPrice && !!packagePrice) && (
                <VerticalSeparator />
              )
            }
            {
              packagePrice && (
                <PackPrice>
                  <i>
                    {labels.spPackageValuePriceLabel} {packagePrice}
                  </i>
                </PackPrice>
              )
            }
          </PackPricesWrapper>
          {!!termsAndConditionsLabel && !!termsAndConditionsURL && (
            <TermsAndConditions onClick={() => onLinkPress(termsAndConditionsURL, true)}>
              {termsAndConditionsLabel}
            </TermsAndConditions>
          )}
        </CardBody>
      </PackageCard>
    </Package>
  )
}

ShoppingPackageCard.propTypes = {
  bookCtaUrl: PropTypes.string,
  name: PropTypes.string,
  image: PropTypes.shape({
    __typename: PropTypes.string,
    altText: PropTypes.string,
    portrait: PropTypes.shape({
      gatsbyImageData: PropTypes.shape({
        images: PropTypes.shape({
          sources: PropTypes.arrayOf(
            PropTypes.shape({
              srcSet: PropTypes.string,
              sizes: PropTypes.string,
              type: PropTypes.string
            })
          )
        }),
        layout: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        placeholder: PropTypes.shape({
          fallback: PropTypes.string
        })
      })
    })
  }),
  memberPrice: PropTypes.number,
  nonMemberPrice: PropTypes.number,
  packageItems: PropTypes.arrayOf(
    PropTypes.shape({
      contentful_id: PropTypes.string,
      highlightTag: PropTypes.string,
      id: PropTypes.string,
      itemDesc: PropTypes.shape({
        childMarkdownRemark: PropTypes.shape({
          html: PropTypes.string
        })
      }),
      name: PropTypes.string,
      __typename: PropTypes.string,
    })
  ),
  packagePrice: PropTypes.number,
  labels: PropTypes.shape({
    spWhatsIncludedLabel: PropTypes.string,
    spBookCtaLabel: PropTypes.string,
    spMemberPriceLabel: PropTypes.string,
    spNonMemberPriceLabel: PropTypes.string,
    spPackageValuePriceLabel: PropTypes.string,
  }),
  villageSlug: PropTypes.string,
  nodeLocale: PropTypes.string,
  termsAndConditionsLabel: PropTypes.string,
  termsAndConditionsURL: PropTypes.string
}

ShoppingPackageCard.defaultProps = {
  bookCtaUrl: '/#',
  image: {
    __typename: 'type_seed',
    altText: 'image',
    portrait: {
      gatsbyImageData: {
        images: {
          sources: [{
            srcSet: '',
            sizes: '',
            type: 'img/png'
          }]
        },
        layout: '',
        width: 250,
        height: 250,
        placeholder: {
          fallback: ''
        }
      }
    }
  },
  memberPrice: '£0',
  name: 'seed',
  nonMemberPrice: '£0',
  packageItems: [
    {
      contentful_id: '011',
      highlightTag: 'seed',
      id: '0111',
      itemDesc: {
        childMarkdownRemark: {
          html: '<span>seed</span>'
        }
      },
      name: 'seed',
      __typename: 'type_seed',
    }
  ],
  packagePrice: '£0',
  labels: {
    // eslint-disable-next-line
    spWhatsIncludedLabel: "What's included",
    spBookCtaLabel: 'BOOK NOW',
    spMemberPriceLabel: 'Member price ',
    spNonMemberPriceLabel: 'Non-member price ',
    spPackageValuePriceLabel: 'Package price ',
  },
  villageSlug:'',
  nodeLocale: 'en',
  termsAndConditionsLabel: '',
  termsAndConditionsURL: ''
}

export default ShoppingPackageCard